<template>
  <Loader v-if="loaderChapters" :loader="loaderChapters" />
  <main
    v-else
    class="flex flex-col"
    :class="[
      {
        'bg-h-primary-100 min-h-screen': alertStore?.show,
        'mx-auto': !alertStore?.show,
        container: progressStore.status === StatusProgress.INIT_OBJECTIVE,
      },
    ]"
  >
    <div>
      <ModalPermissionBrowser />
      <SpeechRecognition v-if="courseStore?.hasSpeechRecognition" />
    </div>

    <FeedbackObjective
      v-if="feedbackStore?.feedback"
      :itemId="learningObjectiveStore?.learningObjective.id"
      :idCourse="courseId"
      :idUser="userId"
      @onSendFeedback="feedbackStore?.sendFeedback"
    />
    <Alert
      v-if="alertStore?.showAlert && !feedbackStore?.feedback"
      :type="alertStore?.type"
      :data="alertStore?.getCurrentData"
      :key="alertStore?.type"
    />
    <QuizStudent
      v-if="progressStore?.status === StatusProgress.INIT_QUIZ"
      @onProceed="quizStore?.proceedQuiz"
      @onEnded="quizStore?.quizEnded"
      @onClose="quizStore?.closeQuiz"
      :quiz="quizStore?.quizData"
      :quizIntro="quizStore?.quizIntro"
      :quizEnded="quizStore?.quizHasEnded"
      :learningName="chapterStore?.getCurrentChapter?.name"
      :isAdaptative="true"
    />
    
    <Material v-if="progressStore?.status === StatusProgress.INIT_OBJECTIVE" />

    <Chat
      v-if="chatStore?.show"
      @onBackMaterial="materialStore?.goBack"
      @onCheckVideoEnded="materialStore?.goNext"
      :indexMaterial="materialStore?.indexMaterial"
      :user="user"
      :msgType="'default'"
      :currentMaterial="materialStore?.getCurrentMaterial"
      :hSize="`!h-[90vh]`"
      class="custom-adapt-chat"
      ref="chat"
    />
    <CourseCertificate
      v-if="progressStore?.status === StatusProgress.CERTIFICATE"
      :courseId="courseId"
      :userId="user.id"
    />
    <CourseLearningMapStudent
      v-if="materialStore?.showMap"
      @onCloseMap="materialStore?.setShowMap"
    />
  </main>
</template>
<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";
import { CourseStudentService } from "../course-student.service";
import { getUserFromStorage } from "@/utils/user-store.util";
import { useAdaptChapterStore } from "@/store/adaptative/adapt-chapter";
import {
  useAdaptProgressStore,
  StatusProgress,
} from "@/store/adaptative/adapt-progress";
import { useAlertStore } from "@/store/adaptative/alert";
import { useAdaptMaterialStore } from "@/store/adaptative/adapt-material";
import { useLearningObjectiveStore } from "@/store/adaptative/learning-objective";
import { useAdaptQuizStore } from "@/store/adaptative/adapt-quiz";
import { useFeedbackStore } from "@/store/adaptative/feedback";
import { useAdaptCourseStore } from "@/store/adaptative/adapt-course";
import { ELoader, useAdaptLoaderStore } from "@/store/adaptative/adapt-loader";
import { useAdaptChatStore } from "@/store/adaptative/adapt-chat";

const Material = defineAsyncComponent(() => import("./Material/material.vue"));
const QuizStudent = defineAsyncComponent(
  () => import("@/views/Quiz/Student/quiz-student.vue")
);
const Alert = defineAsyncComponent(
  () => import("./AlertsCourse/alerts-course.vue")
);
const Feedback = defineAsyncComponent(() => import("./Feedback/feedback.vue"));
const FeedbackObjective = defineAsyncComponent(
  () => import("./Feedback/FeedbackObjective/feedback-objective.vue")
);
const Chat = defineAsyncComponent(
  () => import("@/components/ChatBot/Chat/chat.vue")
);
const CourseCertificate = defineAsyncComponent(
  () => import("./CourseCertificate/course-certificate.vue")
);
const HistoryMaterials = defineAsyncComponent(
  () => import("@/components/Material/HistoryMaterials/history-materials.vue")
);
const SkipVideo = defineAsyncComponent(
  () => import("./SkipVideo/skip-video.vue")
);

export default defineComponent({
  name: "CourseContent",
  components: {
    Material,
    QuizStudent,
    Alert,
    Feedback,
    FeedbackObjective,
    Chat,
    CourseCertificate,
    HistoryMaterials,
    SkipVideo,
  },
  data() {
    return {
      user: getUserFromStorage(),
      userId: getUserFromStorage().id,
      courseId: this.$route.params.id as string,
      skipModal: false,
    };
  },
  setup() {
    const courseStore = useAdaptCourseStore;
    const chapterStore = useAdaptChapterStore;
    const progressStore = useAdaptProgressStore;
    const quizStore = useAdaptQuizStore;
    const alertStore = useAlertStore;
    const materialStore = useAdaptMaterialStore;
    const learningObjectiveStore = useLearningObjectiveStore;
    const feedbackStore = useFeedbackStore;
    const chatStore = useAdaptChatStore;
    return {
      courseStore,
      chapterStore,
      progressStore,
      StatusProgress,
      quizStore,
      alertStore,
      materialStore,
      learningObjectiveStore,
      feedbackStore,
      chatStore,
    };
  },
  async mounted() {
    await this.getCourseById();
    this.progressStore?.setNextState();
  },
  unmounted() {
    this.chapterStore?.$reset();
    this.progressStore?.$reset();
    this.quizStore?.$reset();
    this.alertStore?.$reset();
    this.materialStore.$reset();
    this.learningObjectiveStore?.$reset();
    this.feedbackStore?.$reset();
    this.courseStore?.$reset();
    this.chatStore?.$reset();
  },
  computed: {
    service(): CourseStudentService {
      return new CourseStudentService();
    },
    loaderChapters() {
      return useAdaptLoaderStore?.load[ELoader.CHAPTERS];
    },
  },
  methods: {
    async getCourseById(): Promise<void> {
      await this.chapterStore?.getCourseById(this.userId, this.courseId);
    },
  },
 
});
</script>
<style lang="scss">

.background {
  background-color: rgba(0, 0, 0, 0.439);
  z-index: 999999999;
}
.survey::-webkit-scrollbar-track {
  @apply bg-slate-50;
}
.survey::-webkit-scrollbar {
  @apply bg-slate-50 w-2;
}
::-webkit-scrollbar-thumb {
  @apply bg-slate-50;
}
.chat-bot {
  @apply shadow-md  border-2 fixed right-0 md:max-w-[32rem] min-w-[300px] w-[95vw] #{!important};
}
</style>
